import React from 'react'

const SkeletonManagementHeader = () => {
    return (
        <div className="management-header xxs:max-w-[95%] xs:max-w-[95%] mx-auto  3xl:max-w-[1480px] h-[220px] ">
            <div className="flex flex-col justify-center gap-[18px]">
                <div className="h-[39px] w-[220px] rounded bg-lightBG animate-pulse" />
                <div className="h-5 w-[180px] rounded bg-lightBG animate-pulse" />
            </div>

            <div className="flex-1 flex flex-row  items-center gap-5 justify-center">
                {[1, 2].map((_, idx) => (
                    <div key={idx} className="flex flex-row items-center justify-end gap-[10px] flex-1 max-w-[350px]">
                        <div>
                            <div className="flex items-center gap-2">
                                <div className="h-5 w-20 rounded bg-lightBG animate-pulse" />
                                <div className="h-[34px] w-[34px] rounded-full bg-lightBG animate-pulse" />
                            </div>
                            <div className="h-4 w-28 rounded bg-lightBG animate-pulse mt-3" />
                            <div className="h-4 w-28 rounded bg-lightBG animate-pulse mt-1" />
                        </div>

                        <div className="h-[106px] w-[106px] rounded-full bg-lightBG animate-pulse" />
                    </div>
                ))}
            </div>
            <div className="flex flex-col justify-center gap-[10px] ml-[100px]">
                <div className="h-[56px] w-[190px] rounded-full border bg-lightBG animate-pulse" style={{ borderColor: '#D1D5DB' }} />
                <div className="h-[56px] w-[190px] rounded-full border bg-lightBG animate-pulse" style={{ borderColor: '#D1D5DB' }} />
            </div>
        </div>
    )
}

export default SkeletonManagementHeader
